export enum PoiOpeningHours {
	AllHours = 'All Hours',
	OpenNow = 'Open Now',
}

export const poiOpeningHours = Object.values(PoiOpeningHours);
